/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

// This file was ported from WebSDK/src/sdk/audio/AudioVolumeMeterFactory.js

import AudioVolumeMeter from './AudioVolumeMeter';

export default class AudioVolumeMeterFactory {
  constructor() {
    this._audioVolumeMeters = {};
  }

  stopAllMeters() {
    Object.values(this._audioVolumeMeters).forEach((meter) => {
      meter.stop();
    });
  }

  getAudioVolumeMeter(stream) {
    if (!this._audioVolumeMeters[stream.id]) {
      this._audioVolumeMeters[stream.id] = new AudioVolumeMeter();
    }

    return this._audioVolumeMeters[stream.id];
  }

  getAudioVolumeMeters() {
    return Object.values(this._audioVolumeMeters);
  }
}